import type { CSSProperties } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { getLogoutUrl } from '../api/client';

const shell: CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
};

const nav: CSSProperties = {
  background: '#fff',
  borderBottom: '1px solid #e5e7eb',
  padding: '12px 24px',
  display: 'flex',
  alignItems: 'center',
  gap: 24,
  flexWrap: 'wrap',
};

const brand: CSSProperties = {
  fontWeight: 600,
  fontSize: 16,
  color: '#1a1a1a',
  marginRight: 8,
};

const linkBase: CSSProperties = {
  fontSize: 14,
  color: '#6b7280',
  textDecoration: 'none',
  padding: '6px 0',
  borderBottom: '2px solid transparent',
};

const linkActive: CSSProperties = {
  color: '#2563eb',
  fontWeight: 600,
  borderBottomColor: '#2563eb',
};

/**
 * Main navigation for authenticated admin routes (PRD: Analytics in main nav).
 */
export function AdminShell() {
  const location = useLocation();
  const workspacesActive = location.pathname.startsWith('/workspaces');
  const analyticsActive = location.pathname.startsWith('/analytics');
  const systemSettingsActive = location.pathname.startsWith('/system-settings');
  const logoutUrl = getLogoutUrl();

  return (
    <div style={shell}>
      <nav style={nav} aria-label="Main">
        <span style={brand}>Admin</span>
        <NavLink to="/workspaces" style={{ ...linkBase, ...(workspacesActive ? linkActive : {}) }}>
          Workspaces
        </NavLink>
        <NavLink
          to="/analytics/adoption"
          style={{ ...linkBase, ...(analyticsActive ? linkActive : {}) }}
        >
          Analytics
        </NavLink>
        <NavLink
          to="/system-settings"
          style={{ ...linkBase, ...(systemSettingsActive ? linkActive : {}) }}
          data-testid="nav-system-settings"
        >
          System settings
        </NavLink>
        <a href={logoutUrl} style={{ ...linkBase, marginLeft: 'auto' }}>
          Log out
        </a>
      </nav>
      <Outlet />
    </div>
  );
}
